var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLanguage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V4H2C1.44772 4 1 4.44772 1 5C1 5.55228 1.44772 6 2 6H8.80301C8.4939 7.34758 7.88565 9.01118 6.7491 10.4968C6.07482 9.61401 5.58629 8.66631 5.23402 7.75387C5.03511 7.23865 4.45619 6.98224 3.94097 7.18115C3.42575 7.38006 3.16933 7.95898 3.36825 8.47421C3.80825 9.61388 4.44627 10.8331 5.35895 11.9639C4.60805 12.6016 3.71115 13.1553 2.64129 13.5668C2.12582 13.765 1.86867 14.3436 2.06692 14.8591C2.26518 15.3746 2.84378 15.6317 3.35925 15.4335C4.70837 14.9146 5.82623 14.2132 6.75147 13.41C7.67659 14.2134 8.79382 14.9152 10.1408 15.4333C10.6562 15.6315 11.2348 15.3744 11.4331 14.8589C11.6313 14.3434 11.3742 13.7648 10.8587 13.5666C9.7883 13.1549 8.8918 12.6027 8.14144 11.9663C9.76147 9.95775 10.5167 7.66329 10.847 6H12C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4H8V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4194 9.60608C18.2618 9.2384 17.9003 9 17.5003 9C17.1002 9 16.7387 9.2384 16.5811 9.60608L12.0811 20.1061C11.8636 20.6137 12.0987 21.2016 12.6063 21.4191C13.114 21.6367 13.7018 21.4016 13.9194 20.8939L15.1597 18H19.8409L21.0811 20.8939C21.2987 21.4016 21.8865 21.6367 22.3942 21.4191C22.9018 21.2016 23.137 20.6137 22.9194 20.1061L18.4194 9.60608ZM18.9837 16L17.5003 12.5386L16.0168 16H18.9837Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLanguage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconLanguage.169de1e42a4edf6b05bfcbc536378574.svg";